/**
 * Converts a list of computedStats objects into a list of datasets per metric
 *
 * Examples :
 *  -
 *
 * @param {Array} computedStats - The list of computedStats
 * @returns {Object} - Datasets per metric
 */
export const convertStatsData = (computedStats) => {
    const activeStats = computedStats.reduce(
        (acc, currentStat) => {
            const cpuStat =
                currentStat.cpu.currentUsageInUserMode +
                currentStat.cpu.currentUsageInKernelMode;

            acc.cpu.push(cpuStat * 1000); // Convert from seconds to milliseconds

            const networkStat =
                currentStat.network.currentReceived +
                currentStat.network.currentTransmitted;

            acc.network.push(networkStat / 1000000); // Convert from Bytes to MegaBytes

            return acc;
        },
        {
            cpu: [],
            network: [],
        }
    );

    return activeStats;
};
